import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'
import 'firebase/functions'

const firebaseConfig = {
    apiKey: "AIzaSyC0uOPrSBQjv9rPSuC6NILok49ahYqseA4",
    authDomain: "ottoupnetic.firebaseapp.com",
    databaseURL: "https://ottoupnetic.firebaseio.com",
    projectId: "ottoupnetic",
    storageBucket: "ottoupnetic.appspot.com",
    // messagingSenderId: "713513855745",
    appId: "1:713513855745:web:2b85221e5718df12474900"
}

firebase.initializeApp(firebaseConfig)

const db = firebase.firestore()
const storage = firebase.storage()
const auth = firebase.auth()
const functions = firebase.functions()
const currentUser = auth.currentUser

export default firebase

export {
    db,
    storage,
    auth,
    currentUser,
    firebase,
    functions
}